import { JobQuery } from "@interfaces/career"
import KyMethod from "./KyMethod"

export default class JobsRepositories extends KyMethod {
  async getRawJobs(query?: Partial<JobQuery>) {
    return this._getData(`/career/jobs`, query)
  }

  protected async getRawJobDetail(category_id: any, position_id: any) {
    return this._getData(`/career/jobs/${category_id}/${position_id}`)
  }

  protected async getRawRelatedJobs(category_name: any, career_id: any) {
    return this._getData(`/career/jobs?category=${category_name}&except=${career_id}`)
  }
}
